import React from 'react';

import routes from 'app/routes';

export default function NoData() {
  return (
    <div className="py-5 border-bottom w-100 text-center">
      <h2>No members to show</h2>

      <div className="mb-4">There are no members to invite at this time.</div>

      <a href={routes.managers.programs.index} className="btn btn-primary">Assign Programs</a>
    </div>
  );
}
